import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.prueflauf-aufgabe-bemerkung';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPrueflaufAufgabeBemerkungEffects {

    PrueflaufAufgabeBemerkung$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_PRUEFLAUF_AUFGABE_BEMERKUNG),
        mergeMap((x: ac.GetPrueflaufAufgabeBemerkungAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getPrueflaufAufgabeBemerkung(x.prueflauf_id, x.aufgabe_id).pipe(
                map((result: any) => {
                    return new ac.GetPrueflaufAufgabeBemerkungErfolgreichAction(result, x.prueflauf_id, x.aufgabe_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetPrueflaufAufgabeBemerkungFehlerAction(error, x.prueflauf_id, x.aufgabe_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufQueryService);
        }
        return this.service;
    }
}
